__turbopack_context__.v({
  "contentfulTextEditor": "ContentfulTextEditor-module__RTi9qa__contentfulTextEditor",
});
